import { Application } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

import { DismissableController } from './controllers/dismissable_controller.js';
import { ResizableTextareaController } from './controllers/resizable_textarea_controller.js';
import { ConfirmationController } from './controllers/confirmation_controller.js';
import { DropdownMenuController } from './controllers/dropdown_menu_controller.js';
import { InfoDisplayController } from './controllers/info_display_controller.js';
import { LocaltimeController } from './controllers/localtime_controller.js';
import { LinkableController } from './controllers/linkable_controller.js';
import { ClipboardController } from './controllers/clipboard_controller.js';
import { PollResultsController } from './controllers/poll_results_controller.js';

// Form Validation Controllers
import { FormController } from './controllers/form_controller.js';
import { InputController } from './controllers/input_controller.js';
import { FieldsetController } from './controllers/fieldset_controller.js';
import { CheckboxValidationController } from './controllers/checkbox_validation_controller.js';
import { PasswordConfirmationController } from './controllers/password_confirmation_controller.js';
import { InteractivityCheckController } from './controllers/interactivity_check_controller.js';

//
import { FormFieldToggleController } from './controllers/form_field_toggle_controller.js';


(() => {
    const application = Application.start()
    application.register("dismissable", DismissableController)
    application.register("resizable-textarea", ResizableTextareaController)
    application.register("confirmation", ResizableTextareaController)
    application.register("dropdown-menu", DropdownMenuController)
    application.register("info-display", InfoDisplayController)
    application.register("localtime", LocaltimeController)
    application.register("linkable", LinkableController)
    application.register("clipboard", ClipboardController)
    application.register("poll-results", PollResultsController)
    // Form Validation
    application.register("form", FormController)
    application.register("input", InputController)
    application.register("fieldset", FieldsetController)
    application.register("checkbox-validation", CheckboxValidationController)
    application.register("password-confirmation", PasswordConfirmationController)
    application.register("interactivity-check", InteractivityCheckController)

    application.register("form-field-toggle", FormFieldToggleController)

})()
